import React from "react";

const Button = (props) => {
	return (
		<>
			<ul className="list-inline mt-20">
				<li className="list-inline-item">
					<span className="waves-input-wrapper waves-effect waves-light">
						<input
							type="submit"
							value={props.type}
							name="rent"
							className="btn btn-offer d-inline-block btn-primary ml-n1 my-1 px-lg-4 px-md-3"
						/>
					</span>
				</li>
			</ul>
		</>
	);
};

export default Button;
